// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".back[data-v-a5ef8812]{padding:2vw 4vw;font-size:7.467vw;color:#242424}", ""]);
// Exports
module.exports = exports;
